module.exports = __webpack_public_path__ + "img/infographic_wind.f007f669.jpg";